import Constant from '@/common/constant/Constant';
import {
    createNewTicketAPI,
} from '@/service/ticketService';
import trI18n from '@/common/utils/trI18n';
import Utils from '@/common/utils/utils';
import { copyFileOfTicketDraftTo, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { updateUsingTicketOfFormListState } from './CreateTicketCommonHandler';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import organizationService from '@/service/organizationService';
import { createKibanaLogForCreateQA } from './QaTicketHandler';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

export const onSubmitCreateInvitationGuestDeskProjectTicket = async (
    argsAll,
    formData,
    userDetail,
    panelId,
    corporationDetail,
    inviteFormDetail,
    enqueueSnackbar,
    tabId,
    panelType,
    fields,
    forceCreate = false,
    lastUserAction
) => {
    argsAll.setIsLoading(true);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    if (formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]?.length) {
        uploadFileS3Result =  await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );
    }

    const requestBody = {
        createTicketRequestDto: {
            orgName: formData.guestOrg ? formData.guestOrg : '',
            projectName: formData.guestProject ? formData.guestProject : '',
            adminEmail: formData.adminMailAdress,
            adminFirstName: formData.adminFirstName,
            adminLastName: formData.adminLastName,
            maxGeneralId: formData.maxGeneralId,
            subDomainInvited: formData.subDomainInvited,
            outline: formData.outline,
            corporationOrigin: corporationDetail.id,
            description: formData.description,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
            type: inviteFormDetail.id,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fields,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            forceCreate: forceCreate ? forceCreate : false,
            ...draftTicketInfo,
        },
    };

    const newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.CREATE_TICKET_MAX_GENERAL_ERROR) {
            argsAll.setConfirmDialogObj({open: true, msg: `${trI18n('USER14MSG022')}`, confirmType: argsAll.DIALOG_CONFIRM_TYPE.FORCE_CREATE_INVITE_GUEST_DESK});
            argsAll.setIsLoading(false);
            return;
        }

        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.SUB_DOMAIN_DUPLICATION) {
            argsAll.setErorsQATicket(
                'subDomainInvited',
                { type: 'manual', message: trI18n(Constant.SUB_DOMAIN_DUPLICATION) },
                { shouldFocus: true }
            );
            argsAll.setIsLoading(false);
            return;
        }

        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.MAX_GENERAL_ID_ERROR) {
            argsAll.setErorsQATicket(
                'maxGeneralId',
                { type: 'manual', message: trI18n(Constant.MAX_GENERAL_ID_ERROR) },
                { shouldFocus: true }
            );
            argsAll.setIsLoading(false);
            return;
        }

        let errList = newTicket?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            enqueueSnackbar(buildSnackbarMessage(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }
        argsAll.setIsLoading(false);
        return;

        // ?
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED_QA,
        formId: inviteFormDetail.id,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    let newCorporation = await organizationService.getCorporationById(argsAll.API, corporationDetail.id);
    argsAll.setCorporationDetail(newCorporation);

    argsAll.setIsLoading(false);
    createKibanaLogForCreateQA(argsAll, argsAll.API, lastUserAction, argsAll.setLastUserAction, newTicket);
    
    updateUsingTicketOfFormListState(argsAll.currentCorporationFormList, argsAll.setCurrentCorporationFormList, argsAll.selectedForm, newTicket);
    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-B2B-SET-NEW-COUNTER-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

    return newTicket;

};
